import React, { useRef, useImperativeHandle, forwardRef, useEffect } from 'react';
import MultiselectDropdown from 'multiselect-react-dropdown';

const Multiselect = forwardRef((props, ref) => {
	const innerRef = useRef(null);

	useImperativeHandle(ref, () => innerRef.current);

	useEffect(() => {
		if (!innerRef.current) return;

		const searchWrapper = innerRef.current.searchWrapper && innerRef.current.searchWrapper.current;
		if (!searchWrapper) return;

		const handleWrapperClick = (event) => {
			const isArrow = event.target.classList.contains('icon_down_dir') || event.target.closest('.icon_down_dir');
			if (isArrow) {
				event.preventDefault();
				event.stopPropagation();

				const isOpen = innerRef.current.state.toggleOptionsList;
				if (isOpen) {
					innerRef.current.onCloseOptionList();
					if (innerRef.current.searchBox && innerRef.current.searchBox.current) {
						innerRef.current.searchBox.current.blur();
					}
				} else {
					if (innerRef.current.searchBox && innerRef.current.searchBox.current) {
						innerRef.current.searchBox.current.focus();
					}
				}
			}
		};

		searchWrapper.addEventListener('click', handleWrapperClick, true);
		return () => {
			searchWrapper.removeEventListener('click', handleWrapperClick, true);
		};
	}, []);

	const handleSelect = (selectedList, selectedItem) => {
		if (props.onSelect) {
			props.onSelect(selectedList, selectedItem);
		}
		setTimeout(() => {
			if (innerRef.current) {
				if (typeof innerRef.current.onCloseOptionList === 'function') {
					innerRef.current.onCloseOptionList();
				}
				if (innerRef.current.searchBox && innerRef.current.searchBox.current) {
					innerRef.current.searchBox.current.blur();
				}
			}
		}, 50);
	};

	const handleRemove = (selectedList, removedItem) => {
		if (props.onRemove) {
			props.onRemove(selectedList, removedItem);
		}
		setTimeout(() => {
			if (innerRef.current) {
				if (typeof innerRef.current.onCloseOptionList === 'function') {
					innerRef.current.onCloseOptionList();
				}
				if (innerRef.current.searchBox && innerRef.current.searchBox.current) {
					innerRef.current.searchBox.current.blur();
				}
			}
		}, 50);
	};

	return (
		<MultiselectDropdown
			{...props}
			ref={innerRef}
			onSelect={handleSelect}
			onRemove={handleRemove}
		/>
	);
});

export default Multiselect;
